import myAxios from '@/api/axios'

// 导航栏一级菜单
export function navbar (paramsList) {
  return myAxios({
    url: '/busiNavBar',
    method: 'get',
    params: paramsList,
    _options: {
      loading_flag: false
    }
  })
}

// 导航栏二级三级菜单
export function navbarSeconds (paramsList) {
  return myAxios({
    url: `/busiNavBar/${paramsList.pid}`,
    method: 'get',
    params: paramsList,
    _options: {
      loading_flag: false
    }
  })
}

// 导航栏产品的二级
export function navbarProductsSeconds () {
  return myAxios({
    url: '/index/product/getProductName',
    method: 'get',
    _options: {
      loading_flag: false
    }
  })
}

// 导航栏解决方案的二级
export function navbarsolutionSeconds () {
  return myAxios({
    url: '/index/solution/getSolutionName',
    method: 'get',
    _options: {
      loading_flag: false
    }
  })
}

// 页脚
export function footerNav () {
  return myAxios({
    url: '/busiNavBar/bottom',
    method: 'get',
    _options: {
      loading_flag: false
    }
  })
}

// 获取森锐动态数据
export function getDynamicNews (paramsList) {
  return myAxios({
    url: '/index/dynamic/list',
    method: 'get',
    params: paramsList,
    _options: {
      loading_flag: true
    }
  })
}

// 获取加入我们数据
export function getJoinUsInfo (paramsList) {
  return myAxios({
    url: '/job',
    method: 'get',
    params: paramsList,
    _options: {
      loading_flag: true
    }
  })
}





// WEBPACK FOOTER //
// ./src/api/common.js